<template>
  <div v-show="totalPosters > 0" class="fixed-posters-action">
    <div class="col-md-12 posters-actions row m-0">
      <span class="col-md-3 col-12 py-2">Selecionados até o momento: {{ totalPosters }}</span>

      <div class="col-md-9 col-12">

        <div class="row d-block">

          <div class="col-md-3 col-sm-12 col-2 float-right">
            <button @click="destroyPosters()"
                    class="btn btn-outline-danger text-danger float-left d-md-none d-block mr-2">
              <i class="fas fa-trash text-danger"></i>
            </button>
          </div>

<!--          Desativado por enquanto-->
<!--          <div class="col-md-2 col-12 mb-1 float-right" v-if="(canShare || isMagazine) && !onlyPrint">-->
<!--            <button-->
<!--                type="button"-->
<!--                @click="generateGif()"-->
<!--                class="btn btn-secondary btn-block text-white"-->
<!--                :disabled="moreThenOneFormatSelected"-->
<!--                :title="moreThenOneFormatSelectedTitle">-->
<!--              <i v-if="generatingGif" class="fas fa-circle-notch fa-spin"></i>-->
<!--              <i v-else class="far fa-file-image"></i>-->
<!--              {{ generateGifText }}-->
<!--            </button>-->
<!--          </div>-->

<!--          Desativado por enquanto-->
<!--          <generate-posters-video-->
<!--              :video-url="videoUrl"-->
<!--              :selected-posters="selectedPosters"-->
<!--              v-if="(canVideo || isMagazine) && !onlyPrint"-->
<!--              :more-then-one-format-selected="moreThenOneFormatSelected"-->
<!--              :more-then-one-format-selected-title="moreThenOneFormatSelectedTitle"-->
<!--              class="col-md-2 col-12 mb-1 float-right">-->
<!--          </generate-posters-video>-->

          <download-posters
              v-if="(canShare || isMagazine) && !onlyPrint"
              :download-url="downloadUrl"
              class="col-md-2 col-12 mb-1 float-right">
          </download-posters>

<!--          Desativado por enquanto-->
<!--          <share-posters-->
<!--              v-if="!isMagazineUpsell && (canShare || isMagazine) && !onlyPrint && canAllowPosterToApp"-->
<!--              :can-allow-to-app='canAllowPosterToApp' class="col-md-3 col-12 mb-1 float-right">-->
<!--          </share-posters>-->

          <template v-if="!notCanEnableActions">

            <div
                v-if="((!isMagazine && canExportPdf) || isMagazine) && onlyPrintOrUpsellSingleFormat"
                class="col-md-3 col-sm-12 col-4 float-right mb-md-0 mb-1">
              <form ref="exportForm" method="POST" :action="exportPdfRoute" id="exportForm" target="_blank">
                <input name="_token" type="hidden" :value="csrf">

                <input v-if="printWithTheme" name="with_theme" type="hidden" :value="printWithTheme">
                <input v-if="printWithoutAdjustments" name="without_print_adjustment" type="hidden"
                       :value="printWithoutAdjustments" id="without_print_adjustment">

                <template v-for="(posters, formatId) in groupedSelectedPosters">
                  <input v-for="poster in posters" type="hidden" :name="`poster[${formatId}][${poster.id}]`"
                         :value="poster.quantity">
                </template>

                <button
                    v-if="!isMagazineUpsell && subDomain !== 'up'"
                    type="button"
                    @click="exportPdf()"
                    class="btn btn-secondary btn-block text-white"
                    :disabled="notCanEnableActions"
                    :title="moreThenOneFormatSelectedTitle">
                  <i class="fa fa-file-pdf mr-1"></i>
                  <span class="d-md-inline-block d-none">Imprimir PDF</span>
                </button>
              </form>
            </div>
            <div v-if="canPrint && onlyPrint" class="col-md-3 col-sm-12 col-5 float-right">

              <form ref="printForm" method="POST" :action="printRoute" id="printForm" target="_blank">
                <input name="_token" type="hidden" :value="csrf">


                <input v-if="printWithTheme" name="with_theme" type="hidden" :value="printWithTheme" id="withTheme">
                <input v-if="printWithoutAdjustments" name="without_print_adjustment" type="hidden"
                       :value="printWithoutAdjustments" id="without_print_adjustment">

                <template v-for="(posters, formatId) in groupedSelectedPosters">
                  <input v-for="poster in posters" type="hidden" :name="`poster[${formatId}][${poster.id}]`"
                         :value="poster.quantity">
                </template>

                <button
                    type="button"
                    id="printButton"
                    @click="printPosters()"
                    :disabled="notCanEnableActions"
                    class="btn btn-secondary btn-block text-white">
                  <i class="fa fa-print mr-1"></i>
                  <span class="d-md-inline-block d-none">Imprimir</span>
                </button>
              </form>
              <print-feedback-form
                  v-if="canSendFeedback"
                  :correct-print-image="correctPrintImage"
                  :print-pdf-button-image="printPdfButtonImage"
                  :print-button-image="printButtonImage"
                  :wrong-print-image="wrongPrintImage">
              </print-feedback-form>
            </div>

          </template>

          <div class="float-right">
            <button v-if="canDelete || canDeleteMultiple" @click="destroyPosters()"
                    class="btn btn-outline-danger text-danger float-left d-md-block d-none mr-5">
              <i class="fas fa-trash text-danger"></i>
            </button>
          </div>

<!--          v-if="paperFormatsLargerThenA4.length > 1 && paperFormatsSmallerThenA4.length === 0 && onlyPrint"-->
          <div v-if="this.uniquePaperFormats.length > 0" class="col-md-10 col-md-offset-1 col-12">
            <h6 class="text-center warning-text">Selecione apenas formatos iguais para impressão.</h6>
<!--              Para imprimir formatos diferentes ao mesmo tempo, selecione apenas cartazes menores que A4!-->
          </div>

          <div v-if="!allow50MoreToPrint" class="col-md-10 col-md-offset-1 col-12">
            <h6 class="text-center warning-text">
              A quantidade permitida para impressão é de até
              {{ formatAllow100MorePrint ? '104' : '50' }}.
            </h6>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import bootbox from '../bootbox.min';
import PrintPoster from './mixins/PrintPoster';
import GeneratePostersVideo from "./GeneratePostersVideo";
import DownloadPosters from "./DownloadPosters";
import PrintFeedbackForm from "./PrintFeedbackForm";

export default {
  name: "posters-actions",
  components: {PrintFeedbackForm, DownloadPosters, GeneratePostersVideo},
  mixins: [PrintPoster],

  props: {
    inHomologation: Boolean,
    inProduction: Boolean,
    canAllowToApp: Boolean,
    canPrint: Boolean,
    subDomain: String,
    canShare: Boolean,
    canVideo: Boolean,
    printRoute: String,
    downloadUrl: String,
    canExportPdf: Boolean,
    exportPdfRoute: String,
    printWithThemeDefault: Boolean,
    dontCallPrintConfirmDefault: Boolean,
    isMagazineMatrix: false,
    gifUrl: String,
    videoUrl: String,
    canSendFeedback: Boolean,
    filterType: {
      default: () => 'print',
    },
    canDelete: {
      type: Boolean,
      default: () => true,
    },
    canDeleteMultiple: {
      type: Boolean,
      default: () => true,
    },
    correctPrintImage: {
      type: String,
      required: false,
    },
    wrongPrintImage: {
      type: String,
      required: false,
    },
    printPdfButtonImage: {
      type: String,
      required: false,
    },
    printButtonImage: {
      type: String,
      required: false,
    },
  },

  watch: {
    selectedPosters: {
      handler: function(posters) {
        const exceptFormatName = ['EP30', 'A4 - Vertical', 'A4 - Horizontal'];
        this.paperFormatsLargerThenA4 = _.uniqBy(posters.filter((poster) => {
              return (poster.format_width > 210 || poster.format_height >= 297) && !exceptFormatName.includes(poster.format);
            }
        ), 'format_id');

        this.paperFormatsSmallerThenA4 = posters.filter((poster) => {
          return !posters.filter(
              (poster) => (poster.format_width > 210 || poster.format_height >= 297) || exceptFormatName.includes(poster.format)
          ).includes(poster)
        });

        let firstPoster = posters[0];

        if (firstPoster) {
          this.uniquePaperFormats = posters.filter(poster => poster.format !== firstPoster.format);
        }

        this.validateQuantity(posters);
      },
      deep: true
    }
  },

  computed: {
    onlyPrintOrUpsellSingleFormat() {
      return this.onlyPrint || (!this.onlyPrint && !this.moreThenOneFormatSelected);
    },

    canAllowPosterToApp() {
      return this.canAllowToApp || (this.isMagazine);
    },

    selectedPosters() {
      const posters = this.$store.getters['printPosters/getSelectedPosters'];
      return posters.filter((poster) => poster.poster_type == this.filterType);
    },

    groupedSelectedPosters() {
      return _.groupBy(this.selectedPosters, 'format_id');
    },

    totalPosters() {
      return this.selectedPosters.length;
    },

    isMagazine() {
      return this.subDomain === 'magazineluiza';
    },

    csrf() {
      return $('meta[name="csrf-token"]').attr('content');
    },

    moreThenOneFormatSelected() {
      return Object.keys(this.groupedSelectedPosters).length > 1;
    },

    moreThenOneFormatSelectedTitle() {
      if (this.moreThenOneFormatSelected)
        return 'Selecione apenas um formato.';
    },

    onlyPrint() {
      return this.filterType === 'print';
    },

    notCanEnableActions() {
      if (this.onlyPrint && this.isMagazine && this.moreThenOneFormatSelected && this.allow50MoreToPrint)
        return true;

      return this.uniquePaperFormats.length > 0 || !this.allow50MoreToPrint

      // return (
      //     this.paperFormatsLargerThenA4.length > 0
      //     && this.paperFormatsSmallerThenA4.length > 0
      //     || this.paperFormatsLargerThenA4.length > 1
      // );
    },

    generateGifText() {
      return (this.generatingGif) ? 'Gerando' : 'Gerar GIF';
    },

    isMagazineUpsell() {
      return this.filterType === 'share' && this.isMagazine;
    }
  },

  data() {
    return {
      printWithTheme: this.isMagazine ? false : this.printWithThemeDefault,
      dontCallPrintConfirm: this.isMagazine ? false : this.dontCallPrintConfirmDefault,
      printWithoutAdjustments: false,
      paperFormatsLargerThenA4: [],
      paperFormatsSmallerThenA4: [],
      uniquePaperFormats: [],
      generatingGif: false,
      allow50MoreToPrint: false,
      formatAllow100MorePrint: false,
    }
  },

  methods: {
    validateQuantity(posters) {
      let allow50MoreToPrint = true;

      for (const poster of posters) {
        this.formatAllow100MorePrint = poster.format === 'TAG4822';

        if (poster.format === 'TAG4822' && poster.quantity > 104) {
          allow50MoreToPrint = false;
        } else if (poster.format !== 'TAG4822' && poster.quantity > 50) {
          allow50MoreToPrint = false;
        }
      }

      this.allow50MoreToPrint = allow50MoreToPrint;
    },

    generateGif() {
      if (this.totalPosters < 2)
        return this.$root.throwFlashMessage('warning', 'Selecione ao menos duas ofertas.');

      return bootbox.prompt({
        title: "Insira a duração de cada oferta em segundos",
        value: 1,
        buttons: {
          confirm: {
            label: 'Gerar',
            className: 'btn btn-outline-secondary',
          },
          cancel: {
            label: 'Cancelar',
            className: 'btn btn-outline-secondary',
          },
        },
        inputType: 'number',
        callback: (duration) => {
          if (duration && !isNaN(duration)) {
            return this.downloadGifFromBackEnd(duration);
          }
        }
      });
    },

    downloadGifFromBackEnd(duration) {
      const vm = this;
      vm.generatingGif = true;

      axios({
        method: 'post',
        url: this.gifUrl,
        data: {posters: this.selectedPosters, duration: duration},
        responseType: 'blob',
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `ofertas.gif`);
        document.body.appendChild(link);
        link.click();
      }).catch((error) => {
        this.$root.throwFlashMessage('danger', 'Houve um problema ao baixar o gif das ofertas.');
      }).finally(() => vm.generatingGif = false);
    },

    destroyPosters() {
      this.$root.$emit('destroy-multiple-posters');
    }
  },
}
</script>

<style scoped>
.fixed-posters-action {
  width: 100%;
  margin-right: auto;
  margin-left: auto;
  position: fixed;
  bottom: 0;
  color: #354558;
  left: 0;
  background-color: #ffffff;
}

.posters-actions {
  display: flex;
  align-items: center;
  padding: 15px 2.5vw;
}

@media screen and (max-width: 768px) {
  .fixed-posters-action {
    padding-left: 0;
    width: 100%;
  }

  .posters-actions {
    padding: 15px;
  }
}

.btn-info {
  background-color: #5d82d1;
  border-color: #2e6da4;
}

.btn-info:hover {
  background-color: #286090;
  border-color: #204d74;
}

.warning-text {
  font-size: 13px;
  font-family: 'Montserrat';
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/PostersActions.vue